import { randomIndex } from './flip-variants'

export const DEAL_LAYOUTS = ['fan', 'row', 'arc', 'spin'] as const

export type DealLayout = (typeof DEAL_LAYOUTS)[number]

export type DealPhase = 'deck' | 'shuffle' | 'dealing' | 'ready' | 'collect'

export type Pose = {
  readonly x: number
  readonly y: number
  readonly r: number
  readonly delay?: number
  readonly ms?: number
}

export function deckPose(i: number, n: number, w: number): Pose {
  return { x: 0, y: w * 0.1 - i * 1.5, r: (i - (n - 1) / 2) * 1.4 }
}

export function dealPose(layout: DealLayout, i: number, n: number, w: number, gap: number): Pose {
  const k = i - (n - 1) / 2
  const step = w + gap
  switch (layout) {
    case 'row':
      return { x: k * step, y: 0, r: 0, delay: i * 110 }
    case 'arc':
      return { x: k * step, y: (k * k - (n - 1) / 2) * w * 0.12, r: k * 7, delay: (Math.abs(k) * 1.5 + (k > 0 ? 0.6 : 0)) * 110 }
    case 'spin':
      return { x: k * step, y: Math.abs(k) * w * 0.05, r: k * 4 + 360, delay: (n - 1 - i) * 110, ms: 900 }
    case 'fan':
      return { x: k * step * 0.82, y: Math.pow(Math.abs(k), 1.6) * w * 0.12, r: k * 9, delay: (Math.abs(k) * 1.5 + (k > 0 ? 0.6 : 0)) * 110 }
  }
}

export function randomLayout(): DealLayout {
  return DEAL_LAYOUTS[randomIndex(DEAL_LAYOUTS.length)] ?? 'fan'
}

export function shuffled<T>(items: readonly T[]): T[] {
  const out = [...items]
  for (let i = out.length - 1; i > 0; i--) {
    const j = randomIndex(i + 1)
    const a = out[i]
    const b = out[j]
    if (a === undefined || b === undefined) continue
    out[i] = b
    out[j] = a
  }
  return out
}
